import React from 'react';
import { motion, useTransform } from 'framer-motion';

const CircleCluster = ({ scrollProgress }) => {
  // Animation Timeline (650vh total):
  // Phase 1: Start at 25% of original size, rapid growth (0 → 0.3)
  // Phase 2: Continue to max size, centered (0.3 → 0.5)
  // Phase 3: Extended white hold (0.5 → 0.7)
  // Phase 4: EVERYTHING SHRINKS TOGETHER (0.7 → 0.8)
  // Phase 5: Strip appears (0.85 → 1.0)
  
  // Scale: Max hold until 0.7, then shrink to small ball by 0.8 (30% of previous 0.12 size)
  const scale = useTransform(scrollProgress, [0, 0.3, 0.5, 0.7, 0.8], [0.04, 0.8, 2.0, 2.0, 0.036]);
  
  // Position: starts centered, stays centered throughout
  const x = useTransform(scrollProgress, [0, 0.5, 0.8, 1.0], [0, 0, 0, 0]);
  const y = useTransform(scrollProgress, [0, 0.5, 0.8, 1.0], [0, 0, 0, 0]);
  
  // Always behind laptop
  const zIndex = 15;
  
  // White background expansion
  // Grow to max by 0.5, Hold until 0.7, Shrink to 0 by 0.8
  const whiteScale = useTransform(scrollProgress, [0, 0.4, 0.5, 0.7, 0.8], [0, 0, 6, 6, 0]);
  const whiteOpacity = useTransform(scrollProgress, [0, 0.4, 0.5, 0.7, 0.8], [0, 0, 1, 1, 0]);

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center pointer-events-none rings-wrap" 
      style={{ 
        zIndex,
        transformOrigin: 'center center',
      }}
    >
      <motion.div 
        style={{ 
          scale, 
          x, 
          y,
          position: 'relative',
          transformOrigin: 'center center',
        }}
        className="relative"
      >
        {/* Outer Circle - Radius 3r - 60% opacity - Round concentric circle */}
        <motion.div
          className="absolute -left-[450px] -top-[450px] w-[900px] h-[900px] rounded-full ring--outer"
          style={{
            background: '#FE8630',
            opacity: 0.6,
          }}
        />

        {/* Middle Circle - Radius 2r - 75% opacity - Round concentric circle */}
        <motion.div
          className="absolute -left-[300px] -top-[300px] w-[600px] h-[600px] rounded-full ring--middle"
          style={{
            background: '#FE8630',
            opacity: 0.75,
          }}
        />

        {/* Inner Circle - Radius r - 100% opacity - Round concentric circle */}
        <motion.div
          className="absolute -left-[150px] -top-[150px] w-[300px] h-[300px] rounded-full ring--inner"
          style={{
            background: '#FE8630',
            opacity: 1.0,
          }}
        />

        {/* White Ring - Expands to fill screen for background transition */}
        <motion.div
          className="absolute -left-[150px] -top-[150px] w-[300px] h-[300px] rounded-full ring--white"
          style={{
            scale: whiteScale,
            opacity: whiteOpacity,
            background: 'radial-gradient(circle, #F9F8F8 0%, #F9F8F8 100%)',
            zIndex: 18,
            willChange: 'transform, opacity',
          }}
        />

        {/* Core Orange Ball (visible when collapsed at end) */}
        <motion.div
          className="absolute -left-[18px] -top-[18px] w-[36px] h-[36px] rounded-full"
          style={{
            background: 'radial-gradient(circle, #FE8630 100%, rgba(254, 134, 48, 0.9) 100%)',
            opacity: useTransform(scrollProgress, [0.78, 0.8, 1], [0, 1, 1]),
            boxShadow: '0 4px 20px rgba(254, 134, 48, 0.4)',
          }}
        />
      </motion.div>
    </div>
  );
};

export default CircleCluster;
